import API_ENDPOINTS from './apiConfig';

export type OtpPurpose = 'REGISTER' | 'RESET';

export const MOBILE_RE = /^[6-9]\d{9}$/;

export interface ApiResult<T = Record<string, unknown>> {
  ok: boolean;
  message: string;
  data: T & { retry_after?: number; attempts_left?: number };
}

const post = async <T,>(url: string, body: unknown): Promise<ApiResult<T>> => {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    let data: any = {};
    try { data = await res.json(); } catch { /* non-JSON */ }
    const ok = res.ok && data?.status === 'success';
    return {
      ok,
      message: data?.message || data?.error || (ok ? 'Success' : 'Something went wrong. Please try again.'),
      data,
    };
  } catch {
    return { ok: false, message: 'Network error. Please check your connection.', data: {} as any };
  }
};

export const sendOtp = (contact_no: string, purpose: OtpPurpose) =>
  post<{ expires_in?: number; resend_in?: number }>(API_ENDPOINTS.OTP_SEND, { contact_no, purpose });

export const verifyOtp = (contact_no: string, purpose: OtpPurpose, otp: string) =>
  post<{ otp_token?: string }>(API_ENDPOINTS.OTP_VERIFY, { contact_no, purpose, otp });

export interface RegisterOtpPayload {
  pu_name: string;
  pu_email: string;
  pud_address: string;
  pu_contact_no: string;
  password: string;
  state_id: string | number;
  city_id: string | number;
  otp_token: string;
}

export const registerWithOtp = (payload: RegisterOtpPayload) =>
  post<{ access_token?: string; code_key?: string }>(API_ENDPOINTS.REGISTRATION_OTP, payload);

export const resetPasswordWithOtp = (contact_no: string, otp_token: string, new_password: string) =>
  post<{ code_key?: string }>(API_ENDPOINTS.RESET_PASSWORD_OTP, { contact_no, otp_token, new_password });